<template>
    <div class="additional-action bank-services">
        <button
            v-click-outside="onClickOutsideHandler"
            :class="['cibButton', 'cibButton_simple', 'cibButton_small', {active: isOpen}]"
            @click="toggleDropdown"
        >
            <span>Интернет-банк</span>
        </button>
        <transition
            name="fade"
            mode="out-in"
        >
            <div
                v-show="isOpen"
                class="bank-services-content"
            >
                <div class="bank-services-content__item bank-services-content__item--disabled">
                    <span class="internet-icon" /> Частным лицам
                </div>
                <div class="bank-services-content__item-inner">
                    <div class="bank-services-content__item--new">
                        <a
                            href="https://my.centrinvest.ru/#/"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="bank-services-content__item-secondary"
                        >
                            Новый Интернет-Банк
                        </a>
                        <div class="bank-services-content__item-caption">new</div>
                    </div>
                    <a
                        href="https://link.centrinvest.ru/"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="bank-services-content__item-secondary"
                    >
                        Интернет-Банк
                    </a>
                </div>
                <a
                    href="https://dbo.centrinvest.ru/sbns-web/ru/html/login.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="bank-services-content__item"
                >
                    <span class="client-icon" /> Бизнесу
                </a>
                <a
                    href="https://qr.centrinvest.ru/login"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="bank-services-content__item"
                >
                    <span class="scanner-icon" /> ВебТСП
                </a>
            </div>
        </transition>
    </div>
</template>

<script>
import {defineComponent, ref} from 'vue';

export default defineComponent({
    name: 'BankServicesDropdown',
    props: {
        isMobile: {
            type: Boolean,
            default: () => false,
        },
    },
    setup() {
        const isOpen = ref(false);

        const toggleDropdown = (delay = 100, value = null) => {
            setTimeout(() => {
                isOpen.value = value ?? !isOpen.value;
            }, delay);
        };

        const onClickOutsideHandler = () => {
            if (isOpen.value) {
                toggleDropdown(100, false);
            }
        };

        return {
            isOpen,
            toggleDropdown,
            onClickOutsideHandler,
        };
    },
});
</script>
